export const serviceCategories = [
  {
    title: "Visa & Immigration Services",
    services: [
      {
        name: "Employee Visa Services",
        description: "Issuance, renewal, and cancellation of employee residency visas in compliance with UAE immigration regulations.",
      },
      {
        name: "Investor & Partner Visa Services",
        description: "Processing of new, renewal, and cancellation applications for investor and partner visas.",
      },
      {
        name: "Golden Visa Services",
        description: "Application and management of 10-year Golden Visas, including standard and real estate\u2013based eligibility categories.",
      },
      {
        name: "Dependent & Domestic Worker Visas",
        description: "Issuance, renewal, and cancellation of visas for family members, maids, drivers, and other sponsored dependents.",
      },
      {
        name: "Tourist & Temporary Visas",
        description: "Processing tourist visas and temporary residency solutions based on short-term stay requirements.",
      },
    ],
  },
  {
    title: "Employment & Labor Services",
    services: [
      {
        name: "Work Permits & MOHRE Services",
        description: "Issuance, renewal, and cancellation of work permits, unpaid leave applications, and MOHRE company registration.",
      },
      {
        name: "Temporary Work Permits",
        description: "Application and renewal of temporary and short-term employment permits.",
      },
      {
        name: "Quota & Labor Allocation Applications",
        description: "Submission and management of employee quota requests with relevant authorities.",
      },
    ],
  },
  {
    title: "Business Setup & Licensing",
    services: [
      {
        name: "New Company Setup",
        description: "End-to-end company formation services across mainland and free zone jurisdictions.",
      },
      {
        name: "Business License Renewal",
        description: "Annual renewal of commercial licenses in accordance with regulatory requirements.",
      },
      {
        name: "Import & Export Code Services",
        description: "Issuance and renewal of import-export codes for trading activities.",
      },
    ],
  },
  {
    title: "Company Amendments & Corporate Changes",
    services: [
      {
        name: "Company Amendment Services",
        description: "Processing amendments related to trade name, legal structure conversion to LLC, share capital, shares, managers, and business location.",
      },
    ],
  },
  {
    title: "Government Registration & Establishment Services",
    services: [
      {
        name: "Establishment Card Services",
        description: "Issuance and renewal of establishment cards.",
      },
      {
        name: "E-Channel Registration & Renewal",
        description: "New registration and renewal of immigration e-channel accounts.",
      },
      {
        name: "PO Box Services",
        description: "Application and renewal of corporate PO boxes.",
      },
    ],
  },
  {
    title: "Identity & Government Card Services",
    services: [
      {
        name: "Emirates ID Services",
        description: "Replacement of lost or damaged Emirates IDs and new Emirates ID applications for GCC partners.",
      },
      {
        name: "E-Signature Card Services",
        description: "Issuance and renewal of authorized electronic signature cards.",
      },
    ],
  },
  {
    title: "Legal, Documentation & Support Services",
    services: [
      {
        name: "Power of Attorney Services",
        description: "Drafting and processing of legally compliant powers of attorney.",
      },
      {
        name: "Contract Drafting Services",
        description: "Preparation of commercial and corporate contracts tailored to business needs.",
      },
      {
        name: "Trademark Renewal",
        description: "Renewal of registered trademarks in line with UAE IP regulations.",
      },
      {
        name: "Document Translation & Support",
        description: "Certified legal translation and documentation assistance for government submissions.",
      },
    ],
  },
];
